import { supabase } from './supabase';

// Notice functions
export const createNotice = async ({ title, content, isPinned = false }) => {
  const { data: notice, error } = await supabase
    .from('notices')
    .insert({
      title,
      content,
      is_pinned: isPinned
    })
    .select()
    .single();

  if (error) throw error;
  return notice;
};

export const getNotice = async (noticeId) => {
  const { data: notice, error } = await supabase
    .from('notices')
    .select(`
      *,
      author:user_id (
        id,
        email,
        profiles (
          username,
          avatar_url
        )
      )
    `)
    .eq('id', noticeId)
    .single();

  if (error) throw error;
  return notice;
};

export const getNotices = async ({ page = 1, limit = 10 }) => {
  const from = (page - 1) * limit;
  const to = from + limit - 1;

  const { data: notices, count, error } = await supabase
    .from('notices')
    .select(`
      *,
      author:user_id (
        id,
        email,
        profiles (
          username,
          avatar_url
        )
      )
    `, { count: 'exact' })
    .order('is_pinned', { ascending: false })
    .order('created_at', { ascending: false })
    .range(from, to);

  if (error) throw error;
  return { notices, count };
};

export const updateNotice = async (noticeId, { title, content, isPinned }) => {
  const updates = {
    title,
    content,
    ...(typeof isPinned === 'boolean' && { is_pinned: isPinned })
  };

  const { data: notice, error } = await supabase
    .from('notices')
    .update(updates)
    .eq('id', noticeId)
    .select()
    .single();

  if (error) throw error;
  return notice;
};

export const deleteNotice = async (noticeId) => {
  const { error } = await supabase
    .from('notices')
    .delete()
    .eq('id', noticeId);

  if (error) throw error;
};

// 합격 스토리 functions
export const createSuccessStory = async ({
  title,
  content,
  examDate,
  examScore,
  studyPeriod,
  state
}) => {
  const { data: story, error } = await supabase
    .from('success_stories')
    .insert({
      title,
      content,
      exam_date: examDate,
      exam_score: examScore,
      study_period: studyPeriod,
      state
    })
    .select()
    .single();

  if (error) throw error;
  return story;
};

export const getSuccessStory = async (storyId) => {
  const { data: story, error } = await supabase
    .from('success_stories')
    .select(`
      *,
      author:user_id (
        id,
        email,
        profiles (
          username,
          avatar_url
        )
      )
    `)
    .eq('id', storyId)
    .single();

  if (error) throw error;
  return story;
};

export const getSuccessStories = async ({ page = 1, limit = 10, state = null }) => {
  let query = supabase
    .from('success_stories')
    .select(`
      *,
      author:user_id (
        id,
        email,
        profiles (
          username,
          avatar_url
        )
      )
    `, { count: 'exact' });

  if (state) {
    query = query.eq('state', state);
  }

  const from = (page - 1) * limit;
  const to = from + limit - 1;

  const { data: stories, count, error } = await query
    .order('created_at', { ascending: false })
    .range(from, to);

  if (error) throw error;
  return { stories, count };
};

export const updateSuccessStory = async (storyId, {
  title,
  content,
  examDate,
  examScore,
  studyPeriod,
  state
}) => {
  const { data: story, error } = await supabase
    .from('success_stories')
    .update({
      title,
      content,
      exam_date: examDate,
      exam_score: examScore,
      study_period: studyPeriod,
      state
    })
    .eq('id', storyId)
    .select()
    .single();

  if (error) throw error;
  return story;
};

export const deleteSuccessStory = async (storyId) => {
  const { error } = await supabase
    .from('success_stories')
    .delete()
    .eq('id', storyId);

  if (error) throw error;
}; 